import { useContext, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { RiCloseFill } from "react-icons/ri"
import { AppSpan, Button, Circle, CustomContainer, FlexColumn, FlexRow, Form, FormGroup, SidePopupContainer } from "src/style"
import { useNotifier } from "react-pop-notifier"
import { IoIosStar } from "react-icons/io"

export const ProductReview: React.FC<any> = ({product, fetchReviews, close}) => {
    const {API} = useContext(ApiContext)
    const {info: { userData }} = useContext(AppInfoContext)
    const {notifier} = useNotifier()
    const [comment, setComment] = useState('')
    const [rating, setRating] = useState(0)

    const firstName = userData?.firstName || 'John'
    const lastName = userData?.firstName ? userData?.lastName : 'Doe'


    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        if (!rating) return notifier.show('Kindly give a rating', 'Validation Response')

        const response = await API.createProductReview({
            productId: product.id,
            rating,
            comment
        })

        if (response) {
            fetchReviews()
            close()
        }

        notifier.show('Review Successfully Submitted', null, 'success')
        close()
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">Leave a review</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <FlexRow gap="1" topMargin="2">
                    <Circle size="4" bgColor='#7E7EFF'>
                        <AppSpan color="#F7F8F9" fontWeight="600">{firstName?.[0]}{lastName?.[0]}</AppSpan>
                    </Circle>
                    <AppSpan color="#3A3A3A" fontWeight="500">{firstName} {lastName}</AppSpan>
                </FlexRow>
                <Form onSubmit={handleSubmit} topMargin='1.5'>
                    <FormGroup>
                        <label>Comment</label>
                        <textarea 
                            placeholder="What's on your mind" 
                            name='comment'
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            required
                        />
                    </FormGroup>  
                    <CustomContainer>
                        <AppSpan color="#344054" fontWeight="500">Tap to give us your rating!</AppSpan>
                        <FlexRow
                            minHeight="12" padding="2" topMargin="0.8"
                            radius="1" borderColor="#EAECF0"
                            justifyContent="center" gap="2.5"
                        >
                            {
                                Array.from(Array(5).keys())?.map((num: number) => {
                                    const bgColor = rating >= (num + 1) ? '#409089' : '#ECEEF0'
                                    return (
                                        <IoIosStar 
                                            fill={bgColor} fontSize='4.4rem' 
                                            key={num} 
                                            onClick={() => setRating(num + 1)}
                                        />
                                    )
                                })
                            }
                        </FlexRow>
                    </CustomContainer>

                    <FlexRow justifyContent='flex-end' topMargin="2">
                        <Button
                            width='8.1'
                            titleSize='1.4' fontWeight="500"
                            height='4' radius='0.8'
                            bottomMargin='1' hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                            Submit
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}

